import { FailedValidSystemsSource } from './ui-slice';

export const hasFailedValidSystemsSource = (
  sources: Record<string, FailedValidSystemsSource[]>,
  configId: string | undefined,
  source: FailedValidSystemsSource
): boolean => (configId ? sources[configId]?.includes(source) ?? false : false);
